"use strict";
var $ = require("../internals/export");
var $find = require("../internals/array-iteration").find;
var addToUnscopables = require("../internals/add-to-unscopables");
var FIND = "find";
var SKIPS_HOLES = true;
if (FIND in []) Array(1)[FIND](function() {
  SKIPS_HOLES = false;
});
$({ target: "Array", proto: true, forced: SKIPS_HOLES }, {
  find: function find(callbackfn) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : void 0);
  }
});
addToUnscopables(FIND);
